module.exports = require("./gd.d.ts");